@use '@/styles/tokens' as *;

/* Figma 587:523530 — a dark translucent pill centred across the canvas top (x=532, w=375 in a 1440
 * frame: 532 + 375/2 = 719.5, half of 1440). Absolute inside the map AREA, not the map, so it does
 * not move when the Grower pans. `z-index: 2` matches the other chrome.
 *
 * D-01: `top` matches `.topControls`'s own value on the Map (99px, see mapping-toolbar.module.scss
 * for why) rather than the pre-full-bleed `var(--space-4)` — this pill sits under the now-floating
 * `<TopNav>` the same way that row does. */
.banner {
  position: absolute;
  top: 99px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Figma gap-6 between the row's two halves is the icon/text gap; the × is pushed to the end. */
  gap: var(--space-5);
  /* Figma py-6 / px-20. No --space-* token sits at 6. */
  padding: 6px var(--space-5);
  border-radius: $radius-pill;
  background: var(--overlay-60);
  /* Figma backdrop-blur-[1.85px]. A filter length sits on no token scale. */
  backdrop-filter: blur(2px);
}

.message {
  display: flex;
  align-items: center;
  /* Figma 6px between the cursor glyph and the text. */
  gap: 6px;
  margin: 0;
  font-size: $font-size-14;
  font-weight: $font-weight-regular;
  color: $color-white-100;
  white-space: nowrap;
}

/* `<CloseButton>` ships a 24px dark dismiss; Figma draws a 20px white X on the dark pill. Colour and
 * glyph size only — the shared focus ring and hit area stay as the component defines them. */
.dismiss {
  background: transparent;
  color: $color-white-100;

  svg {
    width: 20px;
    height: 20px;
  }
}
